import { Theme } from '@mui/material'
import { SelectUnitRow } from '../types'

export const getWidth = (x: SelectUnitRow) => (x.size === '5x10' ? 48 : '')

export const getBackgroundColor = (x: SelectUnitRow, theme: Theme) =>
  x.isUnavailable || !x.isSelectable
    ? ''
    : x.isSelected
      ? theme.palette.warning.dark
      : theme.palette.background.default

export const getBackgroundClimateColor = (x: SelectUnitRow, theme: Theme) =>
  x.isUnavailable || !x.isSelectable
    ? ''
    : x.isSelected
      ? theme.palette.warning.dark
      : theme.palette.info.dark

export const getSelectedColor = (x: SelectUnitRow, theme: Theme) =>
  x.isSelected
    ? theme.palette.text.primary
    : x.isUnavailable || !x.isSelectable
      ? theme.palette.text.disabled
      : theme.palette.text.primary

export const getCursor = (x: SelectUnitRow) =>
  x.isUnavailable || !x.isSelectable ? 'not-allowed' : 'pointer'
